// eslint-disable-next-line max-len
export const UPDATE_MANUALLY_FRAMEWORK_CHILD_OBSERVATION_PROGRESS = 'UPDATE_MANUALLY_FRAMEWORK_CHILD_OBSERVATION_PROGRESS'

export const UPDATE_FRAMEWORK_CHILD_OBSERVATION_PROGRESS = 'UPDATE_FRAMEWORK_CHILD_OBSERVATION_PROGRESS'
export const UPDATE_FRAMEWORK_CHILD_OBSERVATION_PROGRESS_FAILED = 'UPDATE_FRAMEWORK_CHILD_OBSERVATION_PROGRESS_FAILED'
export const UPDATE_FRAMEWORK_CHILD_OBSERVATION_PROGRESS_SUCCESS = 'UPDATE_FRAMEWORK_CHILD_OBSERVATION_PROGRESS_SUCCESS'
